import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=2f0c85b5&scoped=true"
var script = {}
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=2f0c85b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c85b5",
  null
  
)

export default component.exports